module.exports = __webpack_public_path__ + "static/media/personal_data_sharing.6b251122.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab-images/personal_data_sharing.jpg
// module id = 218
// module chunks = 0